/**
 * Cerbos resource kind for UI navigation access checks.
 * The string value `'UINavigation'` must match the Cerbos policy resource kind.
 */
export const UINavigationCommands = {
  UINavigation: 'UINavigation',
} as const;

export type UINavigationResource = (typeof UINavigationCommands)[keyof typeof UINavigationCommands];
